/* unplugin-vue-components disabled */import { render } from "./PasswordVerify.vue?vue&type=template&id=a8019d3e"
import script from "./PasswordVerify.vue?vue&type=script&lang=js"
export * from "./PasswordVerify.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__